import React, { useRef } from 'react';
import { When } from 'react-if';
import { useViewportDevice } from '@zep/react';
import { Spacing } from '@zep/ui';
import { SearchFilterContextProvider } from '../../../../contexts';
import S from '../../../../views/home/spaces.module.scss';
import { Banners } from '../../common';
import { MobileActionButtons, SpaceList, TopBar } from '../SpaceListContent';
export const MainSpacePage = () => {
  const {
    isMobile
  } = useViewportDevice();
  const spaceContentRef = useRef<HTMLDivElement>(null);
  return <>
      <div className={S.banners_wrapper}>
        <Banners data-sentry-element="Banners" data-sentry-source-file="MainSpacePage.tsx" />
      </div>
      <Spacing size={12} data-sentry-element="Spacing" data-sentry-source-file="MainSpacePage.tsx" />
      <div ref={spaceContentRef} className={S.content_wrapper}>
        <SearchFilterContextProvider data-sentry-element="SearchFilterContextProvider" data-sentry-source-file="MainSpacePage.tsx">
          <TopBar spaceContentRef={spaceContentRef} data-sentry-element="TopBar" data-sentry-source-file="MainSpacePage.tsx" />
          <Spacing size={20} data-sentry-element="Spacing" data-sentry-source-file="MainSpacePage.tsx" />
          <div className={S.space_list_wrapper}>
            <SpaceList data-sentry-element="SpaceList" data-sentry-source-file="MainSpacePage.tsx" />
          </div>
        </SearchFilterContextProvider>
      </div>
      <When condition={isMobile} data-sentry-element="When" data-sentry-source-file="MainSpacePage.tsx">
        <div className={S.mobile_buttons_wrapper}>
          <MobileActionButtons data-sentry-element="MobileActionButtons" data-sentry-source-file="MainSpacePage.tsx" />
        </div>
      </When>
    </>;
};